import React from 'react';
import commonStyles from '../Pages.module.scss';
import { useBrand } from 'app/contexts/Brand/BrandContext';
import { CurrencyOnboardingHelp } from 'app/containers/Onboarding/SharedPages/Currency/CurrencyOnboardingHelp';

const BillingExportPageHelp = {};

BillingExportPageHelp.accountStorage = (azureBillingExportAccountStorageHelp) => ({
  component: () => (
    <p className={commonStyles.helpText}>
      From the <span>Storage accounts</span> page, enter the <span>Name</span> of the storage account you created.
    </p>
  ),
  image: azureBillingExportAccountStorageHelp,
  imageHeight: 246,
});

BillingExportPageHelp.containerName = (azureBillingExportContainerHelp) => ({
  component: () => (
    <p className={commonStyles.helpText}>
      Go to <span>Data storage &gt; Containers</span> and copy the <span>name of the container</span> that holds your
      export.
    </p>
  ),
  image: azureBillingExportContainerHelp,
  imageHeight: 246,
});

BillingExportPageHelp.directoryPrefix = (azureBillingExportDirectoryPrefixHelp) => ({
  component: () => (
    <p className={commonStyles.helpText}>
      Enter the <span>directory field</span> you defined for the export.
    </p>
  ),
  image: azureBillingExportDirectoryPrefixHelp,
  imageHeight: 267,
});

BillingExportPageHelp.costType = (azureBillingExportCostTypeHelp) => ({
  component: () => {
    const brand = useBrand();
    return (
      <p className={commonStyles.helpText}>
        Choose the export <span>cost type</span> you selected while creating the export for {brand.name}.
      </p>
    );
  },
  image: azureBillingExportCostTypeHelp,
  imageHeight: 246,
});

BillingExportPageHelp.providerCurrency = {
  component: () => (
    <div className={commonStyles.helpText}>
      <div>
        <div>Set the provider currency for this account as it is defined in Azure.</div>
        <div>This currency will be used in our platform.</div>
        <div>To find your billing currency, go to the Azure Console and navigate</div>
        <div>
          to: <b>Cost Management + Billing &gt; Billing profiles.</b>
        </div>
      </div>
    </div>
  ),
};

BillingExportPageHelp.processingCurrency = {
  component: () => <CurrencyOnboardingHelp />,
};

export default BillingExportPageHelp;
